import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {
    ICardNetworkViewModel
} from "../../../../services/booking/models/payment/methods/card/networks/card-network.view-model.interface";

const CardNetworkLogosBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap8};
    width: 100%;
`

interface SupportedCardNetworksSmallComponentProps {
    networks: ICardNetworkViewModel[]
}
export const SupportedCardNetworksSmallComponent: React.FC<SupportedCardNetworksSmallComponentProps> = observer((props) => {

    const renderOneNetwork = (network: ICardNetworkViewModel) => {
        return (<React.Fragment key={network.code}>
            {network.renderIcon({useSmallIcon: true})}
        </React.Fragment>)
    }
    return (
        <CardNetworkLogosBox>
            {
                props.networks.map(renderOneNetwork)
            }
        </CardNetworkLogosBox>
    );
})